export default __webpack_public_path__ + "static/media/owl.760c5e0b.png";